/**
 * theme.js — capa de tokens día/noche de la landing (navy #1c3f74 + lima #7cc23e + glass).
 * Lee `theme` de useTheme() y devuelve clases Tailwind. NO depende del CSS global
 * html.light-mode (que solo pinta el dashboard) → el toggle re-pinta la landing de verdad,
 * sin tocar el tema del dashboard ni las landing white-label de tenants.
 *
 * Regla de contraste: la lima solo va como relleno/borde/ícono; como TEXTO en modo día
 * se oscurece (#4a8c00) porque lima sobre blanco no pasa WCAG.
 */
export function tokens(theme) {
  const dark = theme !== 'light';
  return {
    dark,
    // fondo base de la página
    page: dark ? 'bg-[#0a1424] text-white' : 'bg-[#f6f9ff] text-slate-900',
    // bandas de sección
    sectionA: dark ? 'bg-[#0a1424]' : 'bg-white',
    sectionB: dark ? 'bg-[#0b1730]' : 'bg-[#f4f7ff]',
    // tarjetas
    surface: dark ? 'bg-white/[0.05] border border-white/10' : 'bg-white border border-slate-200 shadow-sm',
    surfaceHover: dark ? 'hover:border-lime-400/40 hover:bg-white/[0.08]' : 'hover:border-lime-400 hover:shadow-lg',
    glass: dark ? 'bg-white/10 backdrop-blur-xl border border-white/15' : 'bg-white/80 backdrop-blur-xl border border-slate-200',
    // navbar
    nav: dark ? 'bg-[#0a1424]/85 backdrop-blur-xl border-b border-white/10' : 'bg-white/90 backdrop-blur-xl border-b border-slate-200',
    // texto
    text: dark ? 'text-white' : 'text-slate-900',
    textSub: dark ? 'text-white/70' : 'text-slate-600',
    textFaint: dark ? 'text-white/50' : 'text-slate-500',
    navLink: dark ? 'text-white/80 hover:text-lime-300' : 'text-slate-700 hover:text-[#1c3f74]',
    // acentos
    accentText: dark ? 'text-lime-400' : 'text-[#4a8c00]',
    accentFill: 'bg-lime-400 text-slate-950 hover:bg-lime-300',
    navy: dark ? 'text-[#7aa8e6]' : 'text-[#1c3f74]',
    // íconos en chip
    iconChip: dark ? 'bg-lime-400/15 border border-lime-400/20 text-lime-300' : 'bg-[#eef7dd] border border-lime-300 text-[#4a8c00]',
    iconChipNavy: dark ? 'bg-white/10 text-white' : 'bg-[#1c3f74] text-white',
    // glow ambiental
    glow: dark
      ? 'bg-[radial-gradient(circle_at_80%_2%,rgba(124,194,62,.14),transparent_45%),radial-gradient(circle_at_5%_98%,rgba(28,63,116,.45),transparent_55%)]'
      : 'bg-[radial-gradient(circle_at_80%_0%,rgba(124,194,62,.10),transparent_45%),radial-gradient(circle_at_0%_100%,rgba(28,63,116,.08),transparent_55%)]',
  };
}
